import AgeAssuranceToast from '@/components/GlobalToast/AgeAssuranceToast'
import CertificationPeerReviewToast from '@/components/GlobalToast/CertificationPeerReviewToast'
import CommunitySurveyToast from '@/components/GlobalToast/CommunitySurveyToast'
import MissingPhoneNumberToast from '@/components/GlobalToast/MissingPhoneNumberToast'
import PolicyUpdateToast from '@/components/GlobalToast/PolicyUpdateToast'
import WebsiteUpdateToast from '@/components/GlobalToast/WebsiteUpdateToast'

export default function GlobalToast() {
  return (
    <>
      <AgeAssuranceToast />
      <PolicyUpdateToast />
      <WebsiteUpdateToast />
      <CertificationPeerReviewToast />
      <MissingPhoneNumberToast />
      <CommunitySurveyToast />
    </>
  )
}
